var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require('@/assets/logo-v_animated.svg')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }